const ro = {
    /**
     * Permissions component
     */
    'Add role': 'Adaugă rol',
    'Define a new role': 'Definește un rol nou',
    'Role name': 'Denumire rol',
    View: 'Vizualizare',
    'Create & Edit': 'Creare & Editare',
    Delete: 'Ștergere',
    Discard: 'Renunță',
    Save: 'Salvează',
    permissions: 'permisiuni',

    /**
     * Formik schema validations
     */
    'You must to declare a valid name for the role!': 'Trebuie să oferiți un nume valid rolului!',
    'The name of the role must be at least 3 characters long!':
        'Denumirea rolului trebuie să conțină cel puțin 3 caractere!',
    'The name of the role is required!': 'Denumirea rolului este obligatorie!',

    /**
     * Role request messages
     */
    'The role was deleted successfully!': 'Rolul a fost șters cu succes!',
    'The role was created successfully!': 'Rolul a fost creat cu succes!',
    'The role was edited successfully!': 'Rolul a fost editat cu succes!',
    'The role must have at least one permission in at least one permissions group!':
        'Rolul trebuie să conțină cel puțin o permisiune, din cel puțin un grup de permisiuni!',

    'Are you sure you want to delete this role?': 'Sunteți sigur că doriți să ștergeți acest rol?',
};

export default { ro };
